import { render, staticRenderFns } from "./UrunSepetYatVilla.vue?vue&type=template&id=51da0a43&scoped=true"
import script from "./UrunSepetYatVilla.vue?vue&type=script&lang=js"
export * from "./UrunSepetYatVilla.vue?vue&type=script&lang=js"
import style0 from "./UrunSepetYatVilla.vue?vue&type=style&index=0&id=51da0a43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51da0a43",
  null
  
)

export default component.exports